import React from "react";
import { motion } from "framer-motion";

// Simple scroll-in wrapper: fades + slides its children up once, when scrolled into view.
const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
